import React, {Component} from 'react';

//模块 通用页头
class Header extends Component {
    constructor(props) {
        super(props);
        this.state = {
            language: 'English',
            toggle: false,
            originUrl: 'https://www.plateno.com/Club/AboutClub/HandBook.html'
        };
    }
    componentDidMount() {
        if (window.location.href.indexOf('plateno') !== -1) {
            console.log('plateno')
            this.setState({
                originUrl: 'https://www.plateno.com/Club/AboutClub/HandBook.html'
            })
        } else if (window.location.href.indexOf('bestwehotel') !== -1) {
            this.setState({
                originUrl: 'http://hotel.bestwehotel.com/Club/AboutClub/HandBook.html'
            })
        }
    }
    render() {
        return (
            <header className={this.state.toggle ? 'red' : ''}>
                <div className="box">
                    <a className="logo" href="https://en.bestwehotel.com"></a>
                    <div className="navigation" id="navigation-root">
                        <a className="home-link" href={this.state.originUrl}>CN</a>
                    </div>
                </div>
            </header>
        );
    }
}

export default Header;